import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setHideUnusedAbnormalityTypes } from '../../reducers/BuildRenderRequestSlice';

export const HideUnusedAbnormalityTypesCheckBox = () => {
  const dispatch = useDispatch();
  const { hideUnusedAbnormalityTypes } = useSelector((state: RootState) => state.buildRenderRequest);

  return (
    <label className="check-row">
      <input
        type="checkbox"
        checked={hideUnusedAbnormalityTypes}
        onChange={e => dispatch(setHideUnusedAbnormalityTypes(e.target.checked))}
      />
      <span>
        Show Only Visible Abnormality Types in Legend
        <span className="info-icon" title="Render only the filtered abnormality types in the legend.">i</span>
      </span>
    </label>
  );
};
